import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { Provider } from '../../redux/lib/react-redux';
import ParamContext from '../../redux/lib/react-redux/components/paramContext';
var _Ext$Redux = Ext.Redux,
    defineStore = _Ext$Redux.defineStore,
    usingRedux = _Ext$Redux.usingRedux,
    invariant = _Ext$Redux.invariant;
var uniqueStoreSymbol = "This_view_has_it's_own_store."; // TODO: 临时去掉了缓存，没想好具体怎么加上去
// const renderedElementSymbol = `I_don't_want_be_rendered_again.`;

export default {
  title: null,

  /**
   * open 时设置标题
   * @param {string} title 
   */
  setTitle: function setTitle(title) {
    this.title = title;
  },
  __storeObj: {},

  /**
   * 在组件的 onDestroy 生命周期销毁特定的 store
   * @param {Number} rootTag native 分配的 rootTag 值
   */
  clearStore: function clearStore(rootTag) {
    if (!!this.__storeObj[rootTag]) {
      this.__storeObj[rootTag] = null;
      delete this.__storeObj[rootTag];
    }
  },

  /**
   * 获取指定 VC 下的实时 store，如果没有就新建一个
   * @param {Number} rootTag 
   * @return store
   */
  getStore: function getStore(rootTag) {
    for (var start = rootTag - 10; start > 0; start -= 10) {
      if (!!this.__storeObj[start]) {
        return this.__storeObj[start];
      }
    }

    this.__storeObj[rootTag] = defineStore();
    return this.__storeObj[rootTag];
  },
  wrapperRouter: function wrapperRouter(Router) {
    var open = Router.open;

    Router.open = function (viewName) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _split = (viewName || '').split(':'),
          _split2 = _slicedToArray(_split, 2),
          name = _split2[0],
          openParam = _split2[1];

      invariant(!openParam || usingRedux(), "\u5728\u672A\u914D\u7F6E 'Ext.defaults.redux.reducer' \u7684\u60C5\u51B5\u4E0B\u4E0D\u80FD\u4F7F\u7528 Router.open('view:%s') \u7684\u529F\u80FD\u3002", openParam); // 只有 param 才会被 native 传回来

      if (!options.param) {
        options.param = {};
      }

      switch (openParam) {
        case 'new':
          options.param[uniqueStoreSymbol] = true;
          break;
      }

      return open.call(Router, name, options);
    };
  },
  shouldShowNavigationBar: function shouldShowNavigationBar(Component) {
    var routerPlugin = Component.routerPlugin,
        globalNavBarOptions = Ext.defaults.navBar,
        isShow = globalNavBarOptions.isShow;

    if (routerPlugin && routerPlugin.isShow !== undefined) {
      isShow = routerPlugin.isShow;
    }

    return isShow;
  },
  wrapperView: function wrapperView(className, Component) {
    var _this = this;

    // 缓存渲染过的页面
    if (!Component.routerPlugin) {
      Component.routerPlugin = {};
    }

    var renderedElementClass = function renderedElementClass(_ref) {
      var _ref$param = _ref.param,
          param = _ref$param === void 0 ? {} : _ref$param,
          rootTag = _ref.rootTag,
          _ref$isQRCTShareStore = _ref.isQRCTShareStore,
          isQRCTShareStore = _ref$isQRCTShareStore === void 0 ? false : _ref$isQRCTShareStore;
      var hasOwnStore = false;

      if (param[uniqueStoreSymbol]) {
        delete param[uniqueStoreSymbol];
        hasOwnStore = true;
      } // open 时传进来的 title


      if (!!_this.title) {
        Component.routerPlugin.title = _this.title;
        _this.title = null;
      }

      if (usingRedux()) {
        var curStore = {};

        if (isQRCTShareStore) {
          // 共享 store
          curStore = _this.getStore(rootTag);
        } else {
          // init store
          curStore = _this.__storeObj[rootTag] = defineStore();
        }

        if (hasOwnStore) {
          var state = curStore.getState && curStore.getState();
          curStore = defineStore(state);
        } // 渲染 Provider 包裹的 component


        return <Provider store={curStore}>
                        <View style={{
            flexGrow: 1,
            flexShrink: 1
          }}>
                            <ParamContext.Provider value={param}>
                                <Component param={param} __rootTag_do_not_change_or_you_will_be_fired={rootTag} />
                            </ParamContext.Provider>
                        </View>
                    </Provider>;
      }

      return <View style={{
        flexGrow: 1,
        flexShrink: 1
      }}>
                    <ParamContext.Provider value={param}>
                        <Component param={param} __rootTag_do_not_change_or_you_will_be_fired={rootTag} />
                    </ParamContext.Provider>
                </View>;
    };

    return function (props) {
      return renderedElementClass(props);
    };
  }
};